__turbopack_context__.v({
  "calendarSidebar": "OrganizerPage-module-scss-module__7HMEgG__calendarSidebar",
  "calendarToggleRegion": "OrganizerPage-module-scss-module__7HMEgG__calendarToggleRegion",
  "container": "OrganizerPage-module-scss-module__7HMEgG__container",
  "content": "OrganizerPage-module-scss-module__7HMEgG__content",
  "contentWithCalendar": "OrganizerPage-module-scss-module__7HMEgG__contentWithCalendar",
  "eventsToolbar": "OrganizerPage-module-scss-module__7HMEgG__eventsToolbar",
  "primaryContent": "OrganizerPage-module-scss-module__7HMEgG__primaryContent",
  "root": "OrganizerPage-module-scss-module__7HMEgG__root",
  "tabsRegion": "OrganizerPage-module-scss-module__7HMEgG__tabsRegion",
  "viewToggleRegion": "OrganizerPage-module-scss-module__7HMEgG__viewToggleRegion",
});
